import { render, staticRenderFns } from "./jingdu.vue?vue&type=template&id=fb94b574&scoped=true&"
import script from "./jingdu.vue?vue&type=script&lang=ts&"
export * from "./jingdu.vue?vue&type=script&lang=ts&"
import style0 from "./jingdu.vue?vue&type=style&index=0&id=fb94b574&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb94b574",
  null
  
)

export default component.exports